import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Name',
    isTitle: true,
    field: 'name',
    component: inputTextField({ req: true })
  })
].concat(defaultColumns)
